import React from 'react'
import { useFormatMessage } from '@babylon/intl'
import PageTitle from '@/components/PageTitle/PageTitle'

import messages from './PartnerLandingPage.messages'

/**
 * Landing page that all embedded partner pages will redirect to first
 * while loading product config to confirm patient uses partner-related flows
 *
 * Page is intended to be wrapped in PrivateRoute/Authentication HoC which
 * authenticates user and fetches product config when authentication is successful.
 *
 */
const PartnerLanding = () => {
  const translate = useFormatMessage()
  return (
    <div className="Content--narrow">
      <PageTitle title={translate(messages.pageTitle)} />
    </div>
  )
}

export default PartnerLanding
